import { render, staticRenderFns } from "./MentalWellnessReports.vue?vue&type=template&id=02e58e1d&scoped=true&lang=pug&"
import script from "./MentalWellnessReports.vue?vue&type=script&lang=js&"
export * from "./MentalWellnessReports.vue?vue&type=script&lang=js&"
import style0 from "./MentalWellnessReports.vue?vue&type=style&index=0&id=02e58e1d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e58e1d",
  null
  
)

export default component.exports